// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2bFLx","buttons":"Footer_buttons__1LoBv"};